module.exports = __webpack_public_path__ + "img/logo.8d817a4c.png";